module.exports = __webpack_public_path__ + "static/media/piggy.5c9d9d0f.jpg";